const doc = [({"en":({"js":({"admin":({"sheet_layouts":({"show":({"show_sheet_layout_name":"Show sheet layout: %{name}", "add_new_box":"Add new box"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;